export default __webpack_public_path__ + "static/media/robotics-engineer.7ec26220.gif";